import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionDivider } from "@/components/SectionDivider";
import { SITE } from "@/constants/testIds";
import { HomeIntroSection } from "@/pages/home/HomeIntroSection";
import { HomePillarsSection } from "@/pages/home/HomePillarsSection";
import { HomeTreatmentsSection } from "@/pages/home/HomeTreatmentsSection";
import { HomePackagesSection } from "@/pages/home/HomePackagesSection";
import { HomePractitionerSection } from "@/pages/home/HomePractitionerSection";
import { HomeBlogSection } from "@/pages/home/HomeBlogSection";
import { HomeTestimonialsSection } from "@/pages/home/HomeTestimonialsSection";
import { HomeShopTeaserSection } from "@/pages/home/HomeShopTeaserSection";
import { HomeConsultationSection } from "@/pages/home/HomeConsultationSection";

const INITIAL_DATA = {
    info: null,
    practitioner: null,
    featured: [],
    packages: [],
    posts: [],
    testimonials: [],
    pillars: [],
};

/**
 * HomePage acts as a thin orchestrator: it fetches all data the page needs and
 * passes slices of that data into focused section components living in
 * `pages/home/*`. Each section is independently testable and easy to reorder.
 */
export default function HomePage() {
    const [data, setData] = useState(INITIAL_DATA);

    useEffect(() => {
        let cancelled = false;
        Promise.all([
            api.siteInfo(),
            api.practitioner(),
            api.treatments({ featured: true }),
            api.packages(),
            api.posts(3),
            api.testimonials(),
            api.pillars(),
        ])
            .then(
                ([info, practitioner, featured, packages, posts, testimonials, pillars]) => {
                    if (cancelled) return;
                    setData({
                        info,
                        practitioner,
                        featured,
                        packages,
                        posts,
                        testimonials,
                        pillars,
                    });
                },
            )
            .catch((err) => console.error("home: failed to load data", err));
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div data-testid={SITE.homeHero}>
            <HomeIntroSection />
            <HomePillarsSection pillars={data.pillars} />
            <HomeTreatmentsSection featured={data.featured} />
            <HomePackagesSection packages={data.packages} />
            <HomePractitionerSection practitioner={data.practitioner} />
            <HomeBlogSection posts={data.posts} />
            <HomeTestimonialsSection testimonials={data.testimonials} />
            <SectionDivider />
            <HomeShopTeaserSection shopUrl={data.info?.shop_url} />
            <HomeConsultationSection />
        </div>
    );
}
